export default "__VITE_ASSET__c1ffb676__"